/**
 * @generated SignedSource<<b1e520c584a6847c0a0ac02705b55c84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HighlightsPanelSaveActionItemsMutation$variables = {
  actionItemText: string;
  isNew: boolean;
  prevActionItemTimestamp: number;
  recordingId: string;
};
export type HighlightsPanelSaveActionItemsMutation$data = {
  readonly saveTranscriptActionItem: {
    readonly meetingRecording: {
      readonly activeSummary: {
        readonly actionItems: ReadonlyArray<{
          readonly assignees: ReadonlyArray<{
            readonly fullName: string;
            readonly userId: string | null;
          }>;
          readonly edited: boolean | null;
          readonly insertedBlockKey: string | null;
          readonly text: string;
          readonly timestamp: number;
        }> | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_meetingRecording">;
    } | null;
    readonly validationError: string | null;
  } | null;
};
export type HighlightsPanelSaveActionItemsMutation = {
  response: HighlightsPanelSaveActionItemsMutation$data;
  variables: HighlightsPanelSaveActionItemsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actionItemText"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNew"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prevActionItemTimestamp"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recordingId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "actionItemText",
    "variableName": "actionItemText"
  },
  {
    "kind": "Variable",
    "name": "isNew",
    "variableName": "isNew"
  },
  {
    "kind": "Variable",
    "name": "prevActionItemTimestamp",
    "variableName": "prevActionItemTimestamp"
  },
  {
    "kind": "Variable",
    "name": "recordingId",
    "variableName": "recordingId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "validationError",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "TranscriptActionItem",
  "kind": "LinkedField",
  "name": "actionItems",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TranscriptActionItemAssignee",
      "kind": "LinkedField",
      "name": "assignees",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "insertedBlockKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "edited",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "context",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "RecordingParticipant",
  "kind": "LinkedField",
  "name": "allRelevantParticipants",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTopUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v10/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HighlightsPanelSaveActionItemsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SaveTranscriptActionItem",
        "kind": "LinkedField",
        "name": "saveTranscriptActionItem",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingSummary",
                "kind": "LinkedField",
                "name": "activeSummary",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "public",
                    "value": false
                  }
                ],
                "kind": "FragmentSpread",
                "name": "HighlightsPanel_meetingRecording"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "HighlightsPanelSaveActionItemsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SaveTranscriptActionItem",
        "kind": "LinkedField",
        "name": "saveTranscriptActionItem",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingSummary",
                "kind": "LinkedField",
                "name": "activeSummary",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "summary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TranscriptDecision",
                    "kind": "LinkedField",
                    "name": "decisions",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TranscriptChapter",
                    "kind": "LinkedField",
                    "name": "chapters",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TranscriptBulletPoint",
                        "kind": "LinkedField",
                        "name": "bulletPoints",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textShort",
                            "storageKey": null
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templatedRecaps",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeRecapTemplate",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExternalAttendees",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingCallEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recordingAndTranscriptWillBeDeleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transcriptDeletionReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recordingDataAutoDeletionDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingRecordedVideoDuration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingRecordingVideoDeletionReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userVideoProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SmartTrackerResult",
                "kind": "LinkedField",
                "name": "smartTrackers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trackerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SmartTrackerMatch",
                    "kind": "LinkedField",
                    "name": "matches",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startTimestamp",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endTimestamp",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "ownerAccount",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showLowLanguageConfidenceRegenerationBanner",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transcript",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoUrl",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "detectedLanguage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "languageConfidenceScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canRegenerateSummary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "regenerationForLanguageIsInProgress",
                        "storageKey": null
                      }
                    ],
                    "type": "MeetingRecording",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecording",
                        "kind": "LinkedField",
                        "name": "baseRecording",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MeetingRecordingClip",
                    "abstractKey": null
                  }
                ],
                "type": "MeetingRecordingInterface",
                "abstractKey": "__isMeetingRecordingInterface"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "60c18f56a81b593fbf2c90d974c5c0d7",
    "id": null,
    "metadata": {},
    "name": "HighlightsPanelSaveActionItemsMutation",
    "operationKind": "mutation",
    "text": "mutation HighlightsPanelSaveActionItemsMutation(\n  $recordingId: ID!\n  $prevActionItemTimestamp: Float!\n  $actionItemText: String!\n  $isNew: Boolean!\n) {\n  saveTranscriptActionItem(recordingId: $recordingId, prevActionItemTimestamp: $prevActionItemTimestamp, actionItemText: $actionItemText, isNew: $isNew) {\n    validationError\n    meetingRecording {\n      activeSummary {\n        actionItems {\n          timestamp\n          text\n          assignees {\n            userId\n            fullName\n          }\n          insertedBlockKey\n          edited\n        }\n        id\n      }\n      ...HighlightsPanel_meetingRecording_1DbIRQ\n      id\n    }\n  }\n}\n\nfragment HighlightsPanel_DecisionsHighlight_decisions on TranscriptDecision {\n  timestamp\n  text\n  context\n}\n\nfragment HighlightsPanel_meetingRecording_1DbIRQ on MeetingRecording {\n  __typename\n  id\n  hasExternalAttendees\n  activeSummary {\n    summary\n    createdAt\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n      insertedBlockKey\n      edited\n    }\n    decisions {\n      ...HighlightsPanel_DecisionsHighlight_decisions\n    }\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        timestamp\n        text\n        textShort\n        context\n      }\n    }\n    templatedRecaps\n    activeRecapTemplate\n    id\n  }\n  title\n  meetingCallEnd\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  recordingDataAutoDeletionDate\n  meetingRecordedVideoDuration\n  ...utils_AddedOrAvailableUntil_meetingRecording\n  userVideoProgress\n  smartTrackers {\n    trackerName\n    matches {\n      startTimestamp\n      endTimestamp\n    }\n  }\n  ownerAccount {\n    __typename\n    id\n  }\n  showLowLanguageConfidenceRegenerationBanner\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ\n  ...TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ\n}\n\nfragment RegenerateForLanguageModalFragment_meetingRecording on MeetingRecording {\n  id\n  detectedLanguage\n  languageConfidenceScore\n  canRegenerateSummary\n  regenerationForLanguageIsInProgress\n}\n\nfragment TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    id\n    detectedLanguage\n    languageConfidenceScore\n    ...RegenerateForLanguageModalFragment_meetingRecording\n  }\n}\n\nfragment TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  transcript\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    allRelevantParticipants {\n      ...TranscriptPanel_SpeakerRelabelForm_attendees\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      allRelevantParticipants {\n        ...TranscriptPanel_SpeakerRelabelForm_attendees\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_SpeakerRelabelForm_attendees on RecordingParticipant {\n  email\n  fullName\n  image\n  isTopUser\n  user {\n    id\n  }\n}\n\nfragment TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  transcript\n  ownerAccount {\n    __typename\n    id\n  }\n}\n\nfragment utils_AddedOrAvailableUntil_meetingRecording on MeetingRecording {\n  meetingCallEnd\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  meetingRecordingVideoDeletionReason\n  recordingDataAutoDeletionDate\n}\n"
  }
};
})();

(node as any).hash = "d86b9a068fc9ff8fd80c29c47f042f50";

export default node;
